import React from 'react';

import Colors from '../../constants/Colors';
import {
  BodyText,
  Container,
  FeatureBlock,
  Grid,
  GridCell,
  Icon,
  Illustration,
  Title,
  Well,
} from '../../components/core';
import Responsive from '../../constants/Responsive';

function PreparingForYourMoveBlock() {
  return (
    <Well backgroundColor={Colors.GrayLight}>
      <Container align="center">
        <Icon name="checklist" style={{ marginBottom: 32 }} />
        <Title weight="bold" size="32" align="center">
          Preparing for your Lugg
        </Title>
        <BodyText size="16" style={{ maxWidth: 610, marginRight: 'auto', marginLeft: 'auto' }}>
          Moving is stressful. We’re here to make it go as smooth as possible. Here are 2 tips to
          make it go even smoother.
        </BodyText>
        <Grid style={{ marginTop: 64 }}>
          <GridCell size={Responsive('size12of12', 'size6of12')} style={{ padding: '0 12px' }}>
            <FeatureBlock
              layout="vertical"
              figure={<Illustration name="bed-with-tools" />}
              title={
                <Title size="26" weight="black" align="center">
                  Disassemble larger items
                </Title>
              }
              body={
                <BodyText size="16">
                  Please disassemble larger items where possible so we can move them safely
                  throughout your home.
                </BodyText>
              }
            />
          </GridCell>
          <GridCell size={Responsive('size12of12', 'size6of12')} style={{ padding: '0 12px' }}>
            <FeatureBlock
              layout="vertical"
              figure={<Illustration name="tv-with-plates" />}
              title={
                <Title size="26" weight="black" align="center">
                  Pack your items
                </Title>
              }
              body={
                <BodyText size="16">
                  Make sure all your items are packed safely and ready to move before we arrive.
                </BodyText>
              }
            />
          </GridCell>
        </Grid>
      </Container>
    </Well>
  );
}

export default PreparingForYourMoveBlock;



// WEBPACK FOOTER //
// ./src/ui/pages/components/PreparingForYourMoveBlock.js